import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import CartProvider from "./context/CartContext";
import WishlistProvider from "./context/WishlistContext";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Collections from "./pages/Collections";
import Contact from "./pages/Contact";
import ProductDetails from "./pages/ProductDetails";
import Category from "./pages/Category";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import OrderSuccess from "./pages/OrderSuccess";
import Wishlist from "./pages/Wishlist";
import TrackOrder from "./pages/TrackOrder";

import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";
import AdminRoute from "./admin/AdminRoute";
import AdminOrders from "./admin/AdminOrders";

function App() {
  return (
    <BrowserRouter>
      <CartProvider>
        <WishlistProvider>
          <Navbar />

          <Routes>
            {/* Customer Pages */}

            <Route path="/" element={<Home />} />

            <Route path="/collections" element={<Collections />} />

            <Route path="/category/:categoryName" element={<Category />} />

            <Route path="/contact" element={<Contact />} />

            <Route path="/product/:id" element={<ProductDetails />} />

            <Route path="/cart" element={<Cart />} />

            <Route path="/checkout" element={<Checkout />} />

            <Route path="/order-success/:orderId" element={<OrderSuccess />} />

            <Route path="/wishlist" element={<Wishlist />} />

            <Route path="/track-order" element={<TrackOrder />} />

            {/* Admin Pages */}

            <Route path="/admin/login" element={<AdminLogin />} />

            <Route
              path="/admin/dashboard"
              element={
                <AdminRoute>
                  <AdminDashboard />
                </AdminRoute>
              }
            />

            <Route
              path="/admin/orders"
              element={
                <AdminRoute>
                  <AdminOrders />
                </AdminRoute>
              }
            />
          </Routes>

          <Footer />
        </WishlistProvider>
      </CartProvider>
    </BrowserRouter>
  );
}

export default App;
